<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
        <el-form :model="addForm" ref="addFormRef" :inline="true" label-width="80px" class="font-bold">
            <el-form-item label="消息内容" prop="content" >
              <el-input size="small" v-model="addForm.content" clearable placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="发送者ID" prop="senderId">
              <el-input size="small" v-model="addForm.senderId" clearable placeholder="请输入ID"></el-input>
            </el-form-item>
            <el-form-item label="接收者ID" prop="receiverId">
              <el-input size="small" v-model="addForm.receiverId" clearable placeholder="请输入ID"></el-input>
            </el-form-item>

          <el-form-item label="时间区间" prop="dateValue">
            <el-date-picker
              v-model="addForm.dateValue"
              size="small"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="dateRangeChange">
            </el-date-picker>
          </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="searchMsgLog(true)">搜索</el-button>
              <el-button size="small" @click="resetInput">重置</el-button>
            </el-form-item>

        </el-form>
      <el-table :data="msgLog" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="头像" prop="Imul" width="52">
          <template slot-scope="scope">
            <el-avatar
              :src="scope.row.SenderImgurl || 'http://zone-yingerfashion.oss-cn-shenzhen.aliyuncs.com/storage/images/avatar/3c1b15bb4b0325b23db64346ba0ac31b.png'"
              style="width: 30px; height: 30px"
            ></el-avatar>
          </template>
        </el-table-column>
        <el-table-column label="发送者" prop="SenderNickname" width="140">
          <template slot-scope="scope">
            {{ !scope.row.sender_id ? '影儿机器人' : scope.row.SenderNickname }}
          </template>
        </el-table-column>
        <el-table-column label="发送者id" prop="sender_id" width="80">
          <template slot-scope="scope">
            {{scope.row.sender_id || '机器人'}}
          </template>
        </el-table-column>
        <el-table-column label="发送类型" prop="sender_type" width="80"></el-table-column>
        <el-table-column label="角色" prop="job_role" width="80"></el-table-column>
        <el-table-column label="渠道" prop="channel" width="120"></el-table-column>
        <el-table-column label="接收者id" prop="receiver_id" width="80">
          <template slot-scope="scope">
            {{scope.row.receiver_id || '机器人'}}
          </template>
        </el-table-column>
        <el-table-column label="id" prop="id" width="160"></el-table-column>
        <el-table-column label="内容" prop="content" style="min-widht:200px;">
          <template v-slot="{ row, $index }">
            <component
                    :is="msgComponentType[row.type]"
                    :item="row"
                    :index="$index"
            ></component>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '0'">未读</span>
            <span v-else>已读</span>
          </template>
        </el-table-column>
        <el-table-column label="消息类型" prop="type" width="80">
          <template v-slot="{ row }">
            {{ msgType[row.type] || row.type }}
          </template>
        </el-table-column>
        <el-table-column label="发送时间" prop="send_at" width="150"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10,20,50,100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
  import { chat_get } from '@/api'
  import msgType from './msgType';
const msgComponentType = {
  0: '', // 未知默认为空
  1: 'msg-text', // 文本
  2: 'msg-face', // 表情
  3: 'msg-voice',
  4: 'msg-image',
  5: 'msg-video',
  6: 'msg-location',
  7: 'msg-goods',
  8: 'msg-order',
  9: '', // 指令 不显示
  // 10: 'msg-activity',
  11: 'msg-logistics', // 物流 不显示
  // 12: 'msg-history', // 聊天记录
  13: 'msg-goods-store', // 库存 不显示 前端不会发此类型给后端，后端会返回此类型给前端
  18: 'mag-cpns',
  19: 'msg-goods-ask',
  23: 'msg-order-ask',
  24: 'msg-card',
  26: 'msg-order-ask'
}
  export default {
    data() {
      return {
        // 获取角色列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },
        total: 0,
        addForm: {
          content: '',
          startTime: '',
          endTime: '',
          senderId: '',
          receiverId: '',
          dateValue: []
        },
        msgLog: [],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        msgComponentType,
        msgType: {
          1: '文本',
          2: '表情',
          3: '语言消息',
          4: '图片',
          5: '文件',
          6: '地理位置',
          7: '商品',
          8: '订单',
          9: '指令推送',
          10: '活动',
          11: '物流',
          12: '聊天记录',
          13: '商品库存',
          14: '客服资料卡显示',
          15: '转人工',
          16: '结束人工',
          17: '开启loading标识',
          18: '优惠券',
          19: '发送商品',
          20: '未读消息列表',
          23: '',
          24: '',
          26: '售后卡'
        }
      };
    },
    components: {
      ...msgType
    },
    created() {
      this.searchMsgLog();
    },
    methods: {
      searchMsgLog(val = false) {
        if (val) this.queryInfo.pagenum = 1;
        let { content, startTime, endTime, senderId, receiverId } = this.addForm;
        chat_get(`/admin/v1/mes?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&startAt=${startTime}&endAt=${endTime}&sender_id=${senderId}&receiver_id=${receiverId}&content=${content}`, {}, res => {
          if(res.data.hasOwnProperty('MessageContent')) {
            this.total = res.data.MessageContent.Count
            res.data.MessageContent.message.forEach(item => {
              try {
                item.content = JSON.parse(item.content)
              }catch(ex) {}
              try {
                item.knowledge = JSON.parse(item.knowledge)
              }catch(ex) {}
            })
            this.msgLog = res.data.MessageContent.message
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.searchMsgLog()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.searchMsgLog()
      },
      dateRangeChange() {
        this.addForm.startTime = this.addForm.dateValue ? this.addForm.dateValue[0] : ''
        this.addForm.endTime = this.addForm.dateValue ? this.addForm.dateValue[1] : ''
        this.searchMsgLog(true);
      },
      resetInput() {
        this.$refs.addFormRef.resetFields()
        this.addForm.startTime = ''
        this.addForm.endTime = ''
        this.searchMsgLog(true)
      }
    }
  }
</script>

<style lang="less" scoped>
</style>
